// Copyright (c) MobiFactory. All rights reserved.
// This source code is the property of MobiFactory. It is exclusively available to customers who have a valid user license.
// See LICENSE.txt file in the project root for full license information.

import { version } from "../../package.json";

/**
 * Helper class for application version
 */
export default class VersionHelper {
  /**
   * Gets the application version
   * @returns app version
   */
  static getAppVersion(): string {
    const regex = /^(\d+\.\d+)\.(\d+)/;
    const match = regex.exec(version);
    if (match) {
      return `${match[1]} r${match[2]}`;
    }
    return version;
  }
}
